import './JewelleryDetailSizeList.svelte.css';
/* src/components/JewelleryDetail/JewelleryDetailSizeList.svelte generated by Svelte v3.46.4 */
import {
	SvelteComponent,
	append,
	attr,
	destroy_each,
	detach,
	element,
	init,
	insert,
	noop,
	null_to_empty,
	safe_not_equal,
	set_data,
	space,
	src_url_equal,
	text
} from "../../../_snowpack/pkg/svelte/internal.js";

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[4] = list[i];
	return child_ctx;
}

// (29:2) {#each jewellery.sizeList as size}
function create_each_block(ctx) {
	let li;
	let strong;
	let t0_value = /*size*/ ctx[4].name + "";
	let t0;
	let t1;
	let span;
	let t2;
	let t3_value = /*size*/ ctx[4].price + "";
	let t3;
	let t4;
	let span_class_value;
	let t5;
	let em;
	let t6;
	let t7_value = /*size*/ ctx[4].totalPrice + "";
	let t7;
	let t8;
	let em_class_value;
	let t9;
	let t10_value = /*zaikoLabel*/ ctx[2][/*getZaikoStatus*/ ctx[1](/*size*/ ctx[4])] + "";
	let t10;
	let t11;
	let li_class_value;

	return {
		c() {
			li = element("li");
			strong = element("strong");
			t0 = text(t0_value);
			t1 = space();
			span = element("span");
			t2 = text("￥");
			t3 = text(t3_value);
			t4 = text("(税込)");
			t5 = text("\n\t\t\t\t↓\n\t\t\t\t");
			em = element("em");
			t6 = text("￥");
			t7 = text(t7_value);
			t8 = text("(税込)");
			t9 = space();
			t10 = text(t10_value);
			t11 = space();
			attr(strong, "class", "svelte-uinfgq");
			attr(span, "class", span_class_value = "" + (null_to_empty(/*size*/ ctx[4].id) + " svelte-uinfgq"));
			attr(em, "class", em_class_value = "lit_total_price_" + /*size*/ ctx[4].id + " svelte-uinfgq");
			attr(li, "class", li_class_value = "" + (null_to_empty(/*zaikoClass*/ ctx[3][/*getZaikoStatus*/ ctx[1](/*size*/ ctx[4])]) + " svelte-uinfgq"));
		},
		m(target, anchor) {
			insert(target, li, anchor);
			append(li, strong);
			append(strong, t0);
			append(li, t1);
			append(li, span);
			append(span, t2);
			append(span, t3);
			append(span, t4);
			append(li, t5);
			append(li, em);
			append(em, t6);
			append(em, t7);
			append(em, t8);
			append(li, t9);
			append(li, t10);
			append(li, t11);
		},
		p(ctx, dirty) {
			if (dirty & /*jewellery*/ 1 && t0_value !== (t0_value = /*size*/ ctx[4].name + "")) set_data(t0, t0_value);
			if (dirty & /*jewellery*/ 1 && t3_value !== (t3_value = /*size*/ ctx[4].price + "")) set_data(t3, t3_value);

			if (dirty & /*jewellery*/ 1 && span_class_value !== (span_class_value = "" + (null_to_empty(/*size*/ ctx[4].id) + " svelte-uinfgq"))) {
				attr(span, "class", span_class_value);
			}

			if (dirty & /*jewellery*/ 1 && t7_value !== (t7_value = /*size*/ ctx[4].totalPrice + "")) set_data(t7, t7_value);

			if (dirty & /*jewellery*/ 1 && em_class_value !== (em_class_value = "lit_total_price_" + /*size*/ ctx[4].id + " svelte-uinfgq")) {
				attr(em, "class", em_class_value);
			}

			if (dirty & /*jewellery*/ 1 && t10_value !== (t10_value = /*zaikoLabel*/ ctx[2][/*getZaikoStatus*/ ctx[1](/*size*/ ctx[4])] + "")) set_data(t10, t10_value);

			if (dirty & /*jewellery*/ 1 && li_class_value !== (li_class_value = "" + (null_to_empty(/*zaikoClass*/ ctx[3][/*getZaikoStatus*/ ctx[1](/*size*/ ctx[4])]) + " svelte-uinfgq"))) {
				attr(li, "class", li_class_value);
			}
		},
		d(detaching) {
			if (detaching) detach(li);
		}
	};
}

function create_fragment(ctx) {
	let div;
	let h3;
	let img;
	let img_src_value;
	let t;
	let ul;
	let each_value = /*jewellery*/ ctx[0].sizeList;
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	return {
		c() {
			div = element("div");
			h3 = element("h3");
			img = element("img");
			t = space();
			ul = element("ul");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			if (!src_url_equal(img.src, img_src_value = /*jewellery*/ ctx[0].assetsUrl + '/common/h3_itempage_sizebox.webp')) attr(img, "src", img_src_value);
			attr(img, "width", "328");
			attr(img, "height", "32");
			attr(img, "alt", "ご希望サイズのデザイン・価格をご確認ください。");
			attr(img, "loading", "lazy");
			attr(h3, "class", "svelte-uinfgq");
			attr(ul, "class", "list-size-view svelte-uinfgq");
			attr(div, "class", "jewellery-size-list svelte-uinfgq");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, h3);
			append(h3, img);
			append(div, t);
			append(div, ul);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(ul, null);
			}
		},
		p(ctx, [dirty]) {
			if (dirty & /*jewellery*/ 1 && !src_url_equal(img.src, img_src_value = /*jewellery*/ ctx[0].assetsUrl + '/common/h3_itempage_sizebox.webp')) {
				attr(img, "src", img_src_value);
			}

			if (dirty & /*zaikoClass, getZaikoStatus, jewellery, zaikoLabel*/ 15) {
				each_value = /*jewellery*/ ctx[0].sizeList;
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(ul, null);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}

				each_blocks.length = each_value.length;
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(div);
			destroy_each(each_blocks, detaching);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { jewellery } = $$props;

	const getZaikoStatus = size => {
		if (size.yoyaku) {
			return 2;
		} else if (size.warning && !size.yoyaku) {
			return 1;
		}

		return 0;
	};

	const zaikoLabel = ['', '※在庫わずか', '※入荷待ち'];
	const zaikoClass = ['', 'beadsQty0', 'beadsQtyBorderLine'];

	$$self.$$set = $$props => {
		if ('jewellery' in $$props) $$invalidate(0, jewellery = $$props.jewellery);
	};

	return [jewellery, getZaikoStatus, zaikoLabel, zaikoClass];
}

class JewelleryDetailSizeList extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { jewellery: 0 });
	}
}

export default JewelleryDetailSizeList;